<template>
  <div class="bg-mk2b333b bg-opacity-5 h-full w-full">
    <!-- 签字 -->
    <div class="w2222 flex flex-col justify-center  transform-gpu rotate-90">
      <div class="wiiii  py-2   flex flex-row overflow-x-scroll">
        <div
          @click="backClick"
          class="flex-shrink-0 ml-4 leading-6 h-6 text-center flex flex-row justify-center"
        >
          <van-icon name="arrow-left" size="1.5rem" color="#B7BBBF" />
          返回
        </div>
        <div class="w-full text-center h-4">
          请在用户签名区域填写您的名字
        </div>
      </div>
      <div class=" wiiii  h-272 border-2"></div>
      <div class="mt-2  flex flex-row justify-end gap-x-1 wiiii">
        <van-button @click="handleGenerate" type="danger"
          >生成签字图片</van-button
        >
        <van-button @click="handleReset">清空画板</van-button>
        <van-button @click="showImageView">查看签名</van-button>
        <van-button @click="sign3Click" type="danger">确认签名</van-button>
      </div>
    </div>

    <vue-esign
      ref="esign"
      class=" absolute top-0 right-12 md:right-60 lg:right-96"
      :width="272"
      :height="812"
      :isCrop="isCrop"
      :lineWidth="lineWidth"
      :lineColor="lineColor"
      :bgColor.sync="bgColor"
    />
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  name: "signqianzi",
  validate() {
    return false;
  },
  // layout: "homeLayout",
  data() {
    return {
      course_id: "",
      order_id: "",
      orderInfo: "",

      dialogVisible: false, // 弹框是否开启
      lineWidth: 6, // 画笔的线条粗细
      lineColor: "#000000", // 画笔的颜色
      bgColor: "", // 画布的背景颜色
      resultImg: "", // 最终画布生成的base64图片
      isCrop: true // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
    };
  },
  mounted() {
    this.course_id = this.$route.query.course_id;

    this.order_id = this.$route.query.order_id;
  },
  methods: {
    backClick() {
      if (process.client) {
        if (window.history.length <= 1) {
          this.$router.push({ name: "index" });
        } else {
          this.$router.back();
        }
      } else {
        this.$router.back();
      }
    },
    // 清空画板
    sign3Click() {
      this.$router.push({
        name: "user-sign-sign4",
        query: this.$route.query
      });
    },
    handleReset() {
      this.$refs.esign.reset();
    },

    showImageView() {
      ImagePreview({
        images: [this.resultImg],
        closeable: true
      });
    },
    // 生成签字图
    handleGenerate() {
      this.$refs.esign
        .generate() // 使用生成器调用把签字的图片转换成为base64图片格式
        .then(res => {
          this.resultImg = res;
        })
        .catch(err => {
          // 画布没有签字时会执行这里提示一下
          this.$message({
            type: "warning",
            message: "请签名后再生成签字图片"
          });
        });

      // 在这里向后端发请求把转换后的base64文件传给后端，后端接收以后再转换成图片做静态图片存储
      // 当然也可以把base64转成流文件blob格式的，类似上传给后端这样，具体哪种方式看后端要求
      setTimeout(() => {
        // 这里要使用定时器稍微延后以后就能取到base64数据了，当然也可以再加一个确认按钮，如：确认使用这张base64签名图片
        // 点击确认以后，在其回调函数中，再把base64的签名图片传给后端用于存储
        console.log("我是签字后的base64图片", this.resultImg);
      }, 200);
      this.dialogVisible = false;
    }
  }
};
</script>
<style>
.shuzhe {
  margin: 0 auto;

  writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
  writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
}
.wiiii {
  width: 100vh;
}
.w2222 {
  height: 100vw;
}
.van-image-preview__overlay {
  background-color: white !important;
}
</style>
